import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const TopOffendersAggCityReportRequest = (values, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RanReportKpis/GenerateTopOffendersAggCityReport`,
	data: { values, userId }
});
